import { useNavigate } from 'react-router-dom';
import { HeadingMedium, HeadingSmall, ParagraphSmall } from 'baseui/typography';
import { Block } from 'baseui/block';
import { Button, KIND, SHAPE } from "baseui/button";
import { ChevronLeft } from 'baseui/icon';
import { IoQrCodeSharp } from 'react-icons/io5';
import { ErrorBoundary } from '../ErrorBoundary';
import { NavigationButton } from '../NavigationButton/NavigationButton';
import { useMediaQuery } from '../../hooks';
import { styled, useStyletron } from 'baseui';
import { ButtonGroup } from 'baseui/button-group';

export interface BasePageLayoutProps {
    header: any,
    subheader?: React.ReactNode | null,
    children: any
    actionButton?: any,
    bottomActionButtons?: React.ReactNode | React.ReactNode[] | undefined
    showNavigateBack?: boolean | undefined
}


export const BasePageLayout = (props: BasePageLayoutProps) => {
    const navigate = useNavigate();
    const [css, theme] = useStyletron();
    const isLarge = useMediaQuery(theme.mediaQuery.large.replace('@media ', ''));

    const fixedRight = isLarge ? `calc(17% + ${theme.sizing.scale500})` : theme.sizing.scale500;
    const fixedBottom = isLarge ? theme.sizing.scale500 : `calc(60px + ${theme.sizing.scale500})`;

    return (
        <ErrorBoundary>
            <MainContainer>
                <HeaderContainer >
                    <div className={css({ display: 'flex', flexDirection: 'row', marginLeft: theme.sizing.scale500, width: '100%' })}  >
                        {props.showNavigateBack &&
                            <Button onClick={() => navigate(-1)} shape={SHAPE.circle} kind={KIND.tertiary} >
                                <ChevronLeft size='scale1000' />
                            </Button>
                        }
                        <div className={css({ display: 'flex', flexDirection: 'column', width: '100%' })}>
                            <HeadingSmall width={'100%'} marginBottom={0} marginTop={0}>{props.header}</HeadingSmall>
                            {props.subheader && <>{props.subheader}</>}
                        </div>
                    </div>
                    {props.actionButton}
                </HeaderContainer>
                <ChildsContainer >
                    {props.children}
                </ChildsContainer>

                {props.bottomActionButtons &&
                    <BottomActionButtonsContainer $right={fixedRight} $bottom={fixedBottom}> {props.bottomActionButtons}</BottomActionButtonsContainer>
                }
            </MainContainer>
        </ErrorBoundary >)

}


const MainContainer = styled<'div', {}>("div", ({ $theme }) => ({
    position: 'relative', height: '100%', width: '100%'
}));

const ChildsContainer = styled<'div', {}>("div", ({ $theme }) => ({
    margin: $theme.sizing.scale500, height: '100%'
}));

const BottomActionButtonsContainer = styled<'div', { $right, $bottom }>("div", ({ $theme, $right, $bottom }) => ({
    position: 'fixed', bottom: $bottom, right: $right
}));

const HeaderContainer = styled<'div', {}>("div", ({ $theme }) => ({
    display: 'flex', flexDirection: 'row', alignItems: 'baseline', justifyContent: 'space-between', width: '100%'
}));